import React from 'react';
import { Language } from '../config/types';
import { labels } from '../config/constants';

interface LanguageSelectorProps {
  currentLanguage: Language;
  onChange: () => void;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ currentLanguage, onChange }) => (
  <button
    onClick={onChange}
    className="px-3 py-1 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
    aria-label={`Change language to ${labels[currentLanguage].changeLanguage}`}
  >
    {labels[currentLanguage].changeLanguage}
  </button>
);